// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Indicator-module__font-s-10___H4qnh {
  font-size: 10px !important;
}

.Indicator-module__font-s-12___SLaPu {
  font-size: 12px !important;
}

.Indicator-module__font-s-13___c1aSq {
  font-size: 13px !important;
}

.Indicator-module__font-s-14___KeG6P {
  font-size: 14px !important;
}

.Indicator-module__font-s-15___pPgLn {
  font-size: 15px !important;
}

.Indicator-module__font-s-16____eYTD {
  font-size: 16px !important;
}

.Indicator-module__font-s-18___BvFU0 {
  font-size: 18px !important;
}

.Indicator-module__font-s-20___X90cM {
  font-size: 20px !important;
}

.Indicator-module__font-s-22___hXLgD {
  font-size: 22px !important;
}

.Indicator-module__font-s-28___LdHeD {
  font-size: 28px !important;
}

.Indicator-module__font-w-400___tVUzL {
  font-weight: 400 !important;
}

.Indicator-module__font-w-500___Ceoe7 {
  font-weight: 500 !important;
}

.Indicator-module__font-w-600___hbGbn {
  font-weight: 600 !important;
}

.Indicator-module__font-w-700___YymLf {
  font-weight: 700 !important;
}

.Indicator-module__p-5___RfEvA {
  padding: 5px !important;
}

.Indicator-module__p-12___EDgYs {
  padding: 12px !important;
}

.Indicator-module__p-16___m8Svs {
  padding: 16px !important;
}

.Indicator-module__p-30___APUTf {
  padding: 30px !important;
}

.Indicator-module__p-b-0___CRQOY {
  padding-bottom: 0 !important;
}

.Indicator-module__p-b-5___uNM2w {
  padding-bottom: 5px !important;
}

.Indicator-module__p-b-10___By463 {
  padding-bottom: 10px !important;
}

.Indicator-module__p-b-12___oIRJH {
  padding-bottom: 12px !important;
}

.Indicator-module__p-b-16___Mwlss {
  padding-bottom: 16px !important;
}

.Indicator-module__p-b-18___Q8bba {
  padding-bottom: 18px !important;
}

.Indicator-module__p-b-20___Pbd3e {
  padding-bottom: 20px !important;
}

.Indicator-module__p-b-25___oouEu {
  padding-bottom: 25px !important;
}

.Indicator-module__p-b-30___mQ8X6 {
  padding-bottom: 30px !important;
}

.Indicator-module__p-b-50___M1Oc6 {
  padding-bottom: 50px !important;
}

.Indicator-module__p-t-0___IQXOu {
  padding-top: 0 !important;
}

.Indicator-module__p-t-12___lpvTu {
  padding-top: 12px !important;
}

.Indicator-module__p-t-16___Zdpw2 {
  padding-top: 16px !important;
}

.Indicator-module__p-t-18___spAod {
  padding-top: 18px !important;
}

.Indicator-module__p-t-20___A3OxI {
  padding-top: 20px !important;
}

.Indicator-module__p-t-30___CKCSJ {
  padding-top: 30px !important;
}

.Indicator-module__p-t-40___uKJDC {
  padding-top: 40px !important;
}

.Indicator-module__p-t-50___VIW9b {
  padding-top: 50px !important;
}

.Indicator-module__p-l-20___ZvI8T {
  padding-left: 20px !important;
}

.Indicator-module__p-l-30___GF8E1 {
  padding-left: 30px !important;
}

.Indicator-module__p-l-40___bEH6B {
  padding-left: 40px !important;
}

.Indicator-module__p-r-16___M_gIM {
  padding-right: 16px !important;
}

.Indicator-module__p-r-20___mF659 {
  padding-right: 20px !important;
}

.Indicator-module__p-r-30___JMzKx {
  padding-right: 30px !important;
}

.Indicator-module__p-r-50___gV6oP {
  padding-right: 50px !important;
}

.Indicator-module__p-r-60___xgIbi {
  padding-right: 60px !important;
}

.Indicator-module__m-b-1___zJMa6 {
  margin-bottom: 1px !important;
}

.Indicator-module__m-b-2___pqWeG {
  margin-bottom: 2px !important;
}

.Indicator-module__m-b-6___Osor5 {
  margin-bottom: 6px !important;
}

.Indicator-module__m-b-8___RSf48 {
  margin-bottom: 8px !important;
}

.Indicator-module__m-b-10___qYg6d {
  margin-bottom: 10px !important;
}

.Indicator-module__m-b-14___oirf1 {
  margin-bottom: 14px !important;
}

.Indicator-module__m-b-16___fzUi_ {
  margin-bottom: 16px !important;
}

.Indicator-module__m-b-20___zN4ER {
  margin-bottom: 20px !important;
}

.Indicator-module__m-b-22___TSlCh {
  margin-bottom: 22px !important;
}

.Indicator-module__m-b-24___Ia1DA {
  margin-bottom: 24px !important;
}

.Indicator-module__m-b-30___V6_61 {
  margin-bottom: 30px !important;
}

.Indicator-module__m-b-32___F7XV8 {
  margin-bottom: 32px !important;
}

.Indicator-module__m-b-40___O8vOO {
  margin-bottom: 40px !important;
}

.Indicator-module__m-t-2___ij4pF {
  margin-top: 2px !important;
}

.Indicator-module__m-t-3___Krgad {
  margin-top: 3px !important;
}

.Indicator-module__m-t-4___WwdiD {
  margin-top: 4px !important;
}

.Indicator-module__m-t-5___BDfm6 {
  margin-top: 5px !important;
}

.Indicator-module__m-t-8___Ad5Aj {
  margin-top: 8px !important;
}

.Indicator-module__m-t-10___tXxKe {
  margin-top: 10px !important;
}

.Indicator-module__m-t-15___asBy5 {
  margin-top: 15px !important;
}

.Indicator-module__m-t-16___K4mw0 {
  margin-top: 16px !important;
}

.Indicator-module__m-t-20___k2OKk {
  margin-top: 20px !important;
}

.Indicator-module__m-t-22___fn7si {
  margin-top: 22px !important;
}

.Indicator-module__m-t-30___h3R2x {
  margin-top: 30px !important;
}

.Indicator-module__m-t-32___wTArF {
  margin-top: 32px !important;
}

.Indicator-module__m-l-auto___Z3uXz {
  margin-left: auto !important;
}

.Indicator-module__m-l-4___nXTRY {
  margin-left: 4px !important;
}

.Indicator-module__m-l-5___ixnZC {
  margin-left: 5px !important;
}

.Indicator-module__m-l-6___FCsLS {
  margin-left: 6px !important;
}

.Indicator-module__m-l-8___lmFzG {
  margin-left: 8px !important;
}

.Indicator-module__m-l-10___lbMoC {
  margin-left: 10px !important;
}

.Indicator-module__m-l-16___ozbyP {
  margin-left: 16px !important;
}

.Indicator-module__m-l-20___xz4SY {
  margin-left: 20px !important;
}

.Indicator-module__m-l-24___okoFj {
  margin-left: 24px !important;
}

.Indicator-module__m-l-30___lSbAa {
  margin-left: 30px !important;
}

.Indicator-module__m-l-35___SHKYx {
  margin-left: 35px !important;
}

.Indicator-module__m-l-40___xdGGp {
  margin-left: 40px !important;
}

.Indicator-module__m-r-8___hTtSJ {
  margin-right: 8px !important;
}

.Indicator-module__m-r-10___dvOBu {
  margin-right: 10px !important;
}

.Indicator-module__m-r-16___NCazj {
  margin-right: 16px !important;
}

.Indicator-module__m-r-20___oBLmS {
  margin-right: 20px !important;
}

.Indicator-module__m-r-24___MHY3A {
  margin-right: 24px !important;
}

.Indicator-module__m-r-30___Mgk4T {
  margin-right: 30px !important;
}

.Indicator-module__m-r-40___hyTGj {
  margin-right: 40px !important;
}

.Indicator-module__border-r-3___Jpph5 {
  border-radius: 3px !important;
}

.Indicator-module__border-r-4___nqzLK {
  border-radius: 4px !important;
}

.Indicator-module__border-r-6___bqXdU {
  border-radius: 6px !important;
}

.Indicator-module__border-r-10___JhGvs {
  border-radius: 10px !important;
}

.Indicator-module__border-r-12___zrPhe {
  border-radius: 12px !important;
}

.Indicator-module__border-r-16___cqZO9 {
  border-radius: 16px !important;
}

.Indicator-module__border-r-50___1gXXm {
  border-radius: 50% !important;
}

.Indicator-module__primary-border___mpTuU {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.Indicator-module__primary-border-b___rm629 {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.Indicator-module__primary-border-t___LrjzX {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.Indicator-module__primary-border-l___T6hFc {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.Indicator-module__primary-border-r___QQYiV {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.Indicator-module__secondary-border___vYMkM {
  border: 1px solid #637768;
}

.Indicator-module__secondary-border-b___aLcoe {
  border-bottom: 1px solid #637768;
}

.Indicator-module__secondary-border-t___DDeqG {
  border-top: 1px solid #637768;
}

.Indicator-module__secondary-border-l___cicdn {
  border-left: 1px solid #637768;
}

.Indicator-module__secondary-border-r___li4NP {
  border-right: 1px solid #637768;
}

.Indicator-module__gap-0___p4gvW {
  gap: 0 !important;
}

.Indicator-module__gap-2___rjrUD {
  gap: 2px !important;
}

.Indicator-module__gap-4___aubWJ {
  gap: 4px !important;
}

.Indicator-module__gap-5___C4UZ6 {
  gap: 5px !important;
}

.Indicator-module__gap-6___EVJVq {
  gap: 6px !important;
}

.Indicator-module__gap-8___JWcXE {
  gap: 8px !important;
}

.Indicator-module__gap-10___cDtsu {
  gap: 10px !important;
}

.Indicator-module__gap-12___TNbRP {
  gap: 12px !important;
}

.Indicator-module__gap-14___JzLcd {
  gap: 14px !important;
}

.Indicator-module__gap-16___kBWw4 {
  gap: 16px !important;
}

.Indicator-module__gap-18___jn3Em {
  gap: 18px !important;
}

.Indicator-module__gap-20___edXhS {
  gap: 20px !important;
}

.Indicator-module__gap-24___SRzIG {
  gap: 24px !important;
}

.Indicator-module__gap-26___kAK37 {
  gap: 26px !important;
}

.Indicator-module__gap-30___N2rag {
  gap: 30px !important;
}

.Indicator-module__gap-32___TBse4 {
  gap: 32px !important;
}

.Indicator-module__gap-40___SGj5k {
  gap: 40px !important;
}

.Indicator-module__gap-50___oVaOL {
  gap: 50px !important;
}

.Indicator-module__flex-1___hmrok {
  flex: 1;
}

.Indicator-module__flex-none___dQHtq {
  flex: none !important;
}

.Indicator-module__flex-column___SgJQq {
  display: flex;
  flex-direction: column !important;
}

.Indicator-module__flex-row___DXfog {
  display: flex;
  flex-direction: row !important;
}

.Indicator-module__vertically-centered___iwERM {
  display: flex;
  align-items: center !important;
}

.Indicator-module__horizontally-centered___Qs7CG {
  display: flex;
  justify-content: center !important;
}

.Indicator-module__horizontally-end___GMfL_ {
  display: flex;
  justify-content: end !important;
}

.Indicator-module__vertically-start___ykFih {
  display: flex;
  align-items: start !important;
}

.Indicator-module__space-between___VOKvl {
  display: flex;
  justify-content: space-between !important;
}

.Indicator-module__flex-wrap___W6RA9 {
  flex-wrap: wrap !important;
}

.Indicator-module__height-100___HZKtS {
  height: 100%;
}

.Indicator-module__width-50___hcxPZ {
  width: 50% !important;
}

.Indicator-module__width-100___zecGv {
  width: 100%;
}

.Indicator-module__cursor-pointer___lmKkn {
  cursor: pointer;
}

.Indicator-module__cursor-not-allowed___r5wOy {
  cursor: not-allowed !important;
}

.Indicator-module__absolute-centered___vryzK {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.Indicator-module__absolute___NRm_Q {
  position: absolute;
}

.Indicator-module__relative___Tshze {
  position: relative;
}

.Indicator-module__fixed___NZwdr {
  position: fixed;
}

.Indicator-module__visible___hAURK {
  opacity: 1;
}

.Indicator-module__invisible___lDtsY {
  opacity: 0;
}

.Indicator-module__col-90___GaSHX {
  width: 90% !important;
}

.Indicator-module__col-auto___vZpcN {
  width: auto !important;
}

.Indicator-module__medical-tabs___Y6Pch {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.Indicator-module__medical-table-new___T8hTX {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.Indicator-module__medical-table-new___T8hTX:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.Indicator-module__medical-table-new___T8hTX::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.Indicator-module__medical-table-new___T8hTX::-webkit-scrollbar-track {
  display: none;
}
.Indicator-module__medical-table-new___T8hTX.Indicator-module__no-pagination___prVm_ {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.Indicator-module__medical-table-new___T8hTX.Indicator-module__no-pagination___prVm_:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.Indicator-module__medical-table-new___T8hTX.Indicator-module__no-pagination___prVm_::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.Indicator-module__medical-table-new___T8hTX.Indicator-module__no-pagination___prVm_::-webkit-scrollbar-track {
  display: none;
}

.Indicator-module__medical-table-empty___U3AO8 {
  padding: 14px 40px !important;
}

.Indicator-module__icon-btn___frUeg {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.Indicator-module__search-icon___KFrk1 {
  width: 24px;
  height: 24px;
  align-self: center;
}

.Indicator-module__disable-select___cdqJX {
  user-select: none;
}

.Indicator-module__break-word___LdBTu {
  word-break: break-word;
}

.Indicator-module__popup-clear-btn___Oi5OJ {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.Indicator-module__scroll-m-b-20___UMNBK {
  scroll-margin-bottom: 20px;
}

.Indicator-module__wrapper___d4odd {
  height: 100%;
  display: flex;
  align-items: flex-start;
}
.Indicator-module__wrapper___d4odd .Indicator-module__text___ACaON {
  background-color: #f1f6f2;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/components/elements/Indicator/Indicator.module.scss","webpack://./../common/src/styles/global/_mixins.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,YAAA;EACA,aAAA;EACA,uBAAA;AA8pBF;AA5pBE;EACE,yBAAA;AA8pBJ","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.wrapper {\n  height: 100%;\n  display: flex;\n  align-items: flex-start;\n\n  .text {\n    background-color: get-color(greenNew, ultra-light);\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `Indicator-module__font-s-10___H4qnh`,
	"fontS12": `Indicator-module__font-s-12___SLaPu`,
	"fontS13": `Indicator-module__font-s-13___c1aSq`,
	"fontS14": `Indicator-module__font-s-14___KeG6P`,
	"fontS15": `Indicator-module__font-s-15___pPgLn`,
	"fontS16": `Indicator-module__font-s-16____eYTD`,
	"fontS18": `Indicator-module__font-s-18___BvFU0`,
	"fontS20": `Indicator-module__font-s-20___X90cM`,
	"fontS22": `Indicator-module__font-s-22___hXLgD`,
	"fontS28": `Indicator-module__font-s-28___LdHeD`,
	"fontW400": `Indicator-module__font-w-400___tVUzL`,
	"fontW500": `Indicator-module__font-w-500___Ceoe7`,
	"fontW600": `Indicator-module__font-w-600___hbGbn`,
	"fontW700": `Indicator-module__font-w-700___YymLf`,
	"p5": `Indicator-module__p-5___RfEvA`,
	"p12": `Indicator-module__p-12___EDgYs`,
	"p16": `Indicator-module__p-16___m8Svs`,
	"p30": `Indicator-module__p-30___APUTf`,
	"pB0": `Indicator-module__p-b-0___CRQOY`,
	"pB5": `Indicator-module__p-b-5___uNM2w`,
	"pB10": `Indicator-module__p-b-10___By463`,
	"pB12": `Indicator-module__p-b-12___oIRJH`,
	"pB16": `Indicator-module__p-b-16___Mwlss`,
	"pB18": `Indicator-module__p-b-18___Q8bba`,
	"pB20": `Indicator-module__p-b-20___Pbd3e`,
	"pB25": `Indicator-module__p-b-25___oouEu`,
	"pB30": `Indicator-module__p-b-30___mQ8X6`,
	"pB50": `Indicator-module__p-b-50___M1Oc6`,
	"pT0": `Indicator-module__p-t-0___IQXOu`,
	"pT12": `Indicator-module__p-t-12___lpvTu`,
	"pT16": `Indicator-module__p-t-16___Zdpw2`,
	"pT18": `Indicator-module__p-t-18___spAod`,
	"pT20": `Indicator-module__p-t-20___A3OxI`,
	"pT30": `Indicator-module__p-t-30___CKCSJ`,
	"pT40": `Indicator-module__p-t-40___uKJDC`,
	"pT50": `Indicator-module__p-t-50___VIW9b`,
	"pL20": `Indicator-module__p-l-20___ZvI8T`,
	"pL30": `Indicator-module__p-l-30___GF8E1`,
	"pL40": `Indicator-module__p-l-40___bEH6B`,
	"pR16": `Indicator-module__p-r-16___M_gIM`,
	"pR20": `Indicator-module__p-r-20___mF659`,
	"pR30": `Indicator-module__p-r-30___JMzKx`,
	"pR50": `Indicator-module__p-r-50___gV6oP`,
	"pR60": `Indicator-module__p-r-60___xgIbi`,
	"mB1": `Indicator-module__m-b-1___zJMa6`,
	"mB2": `Indicator-module__m-b-2___pqWeG`,
	"mB6": `Indicator-module__m-b-6___Osor5`,
	"mB8": `Indicator-module__m-b-8___RSf48`,
	"mB10": `Indicator-module__m-b-10___qYg6d`,
	"mB14": `Indicator-module__m-b-14___oirf1`,
	"mB16": `Indicator-module__m-b-16___fzUi_`,
	"mB20": `Indicator-module__m-b-20___zN4ER`,
	"mB22": `Indicator-module__m-b-22___TSlCh`,
	"mB24": `Indicator-module__m-b-24___Ia1DA`,
	"mB30": `Indicator-module__m-b-30___V6_61`,
	"mB32": `Indicator-module__m-b-32___F7XV8`,
	"mB40": `Indicator-module__m-b-40___O8vOO`,
	"mT2": `Indicator-module__m-t-2___ij4pF`,
	"mT3": `Indicator-module__m-t-3___Krgad`,
	"mT4": `Indicator-module__m-t-4___WwdiD`,
	"mT5": `Indicator-module__m-t-5___BDfm6`,
	"mT8": `Indicator-module__m-t-8___Ad5Aj`,
	"mT10": `Indicator-module__m-t-10___tXxKe`,
	"mT15": `Indicator-module__m-t-15___asBy5`,
	"mT16": `Indicator-module__m-t-16___K4mw0`,
	"mT20": `Indicator-module__m-t-20___k2OKk`,
	"mT22": `Indicator-module__m-t-22___fn7si`,
	"mT30": `Indicator-module__m-t-30___h3R2x`,
	"mT32": `Indicator-module__m-t-32___wTArF`,
	"mLAuto": `Indicator-module__m-l-auto___Z3uXz`,
	"mL4": `Indicator-module__m-l-4___nXTRY`,
	"mL5": `Indicator-module__m-l-5___ixnZC`,
	"mL6": `Indicator-module__m-l-6___FCsLS`,
	"mL8": `Indicator-module__m-l-8___lmFzG`,
	"mL10": `Indicator-module__m-l-10___lbMoC`,
	"mL16": `Indicator-module__m-l-16___ozbyP`,
	"mL20": `Indicator-module__m-l-20___xz4SY`,
	"mL24": `Indicator-module__m-l-24___okoFj`,
	"mL30": `Indicator-module__m-l-30___lSbAa`,
	"mL35": `Indicator-module__m-l-35___SHKYx`,
	"mL40": `Indicator-module__m-l-40___xdGGp`,
	"mR8": `Indicator-module__m-r-8___hTtSJ`,
	"mR10": `Indicator-module__m-r-10___dvOBu`,
	"mR16": `Indicator-module__m-r-16___NCazj`,
	"mR20": `Indicator-module__m-r-20___oBLmS`,
	"mR24": `Indicator-module__m-r-24___MHY3A`,
	"mR30": `Indicator-module__m-r-30___Mgk4T`,
	"mR40": `Indicator-module__m-r-40___hyTGj`,
	"borderR3": `Indicator-module__border-r-3___Jpph5`,
	"borderR4": `Indicator-module__border-r-4___nqzLK`,
	"borderR6": `Indicator-module__border-r-6___bqXdU`,
	"borderR10": `Indicator-module__border-r-10___JhGvs`,
	"borderR12": `Indicator-module__border-r-12___zrPhe`,
	"borderR16": `Indicator-module__border-r-16___cqZO9`,
	"borderR50": `Indicator-module__border-r-50___1gXXm`,
	"primaryBorder": `Indicator-module__primary-border___mpTuU`,
	"primaryBorderB": `Indicator-module__primary-border-b___rm629`,
	"primaryBorderT": `Indicator-module__primary-border-t___LrjzX`,
	"primaryBorderL": `Indicator-module__primary-border-l___T6hFc`,
	"primaryBorderR": `Indicator-module__primary-border-r___QQYiV`,
	"secondaryBorder": `Indicator-module__secondary-border___vYMkM`,
	"secondaryBorderB": `Indicator-module__secondary-border-b___aLcoe`,
	"secondaryBorderT": `Indicator-module__secondary-border-t___DDeqG`,
	"secondaryBorderL": `Indicator-module__secondary-border-l___cicdn`,
	"secondaryBorderR": `Indicator-module__secondary-border-r___li4NP`,
	"gap0": `Indicator-module__gap-0___p4gvW`,
	"gap2": `Indicator-module__gap-2___rjrUD`,
	"gap4": `Indicator-module__gap-4___aubWJ`,
	"gap5": `Indicator-module__gap-5___C4UZ6`,
	"gap6": `Indicator-module__gap-6___EVJVq`,
	"gap8": `Indicator-module__gap-8___JWcXE`,
	"gap10": `Indicator-module__gap-10___cDtsu`,
	"gap12": `Indicator-module__gap-12___TNbRP`,
	"gap14": `Indicator-module__gap-14___JzLcd`,
	"gap16": `Indicator-module__gap-16___kBWw4`,
	"gap18": `Indicator-module__gap-18___jn3Em`,
	"gap20": `Indicator-module__gap-20___edXhS`,
	"gap24": `Indicator-module__gap-24___SRzIG`,
	"gap26": `Indicator-module__gap-26___kAK37`,
	"gap30": `Indicator-module__gap-30___N2rag`,
	"gap32": `Indicator-module__gap-32___TBse4`,
	"gap40": `Indicator-module__gap-40___SGj5k`,
	"gap50": `Indicator-module__gap-50___oVaOL`,
	"flex1": `Indicator-module__flex-1___hmrok`,
	"flexNone": `Indicator-module__flex-none___dQHtq`,
	"flexColumn": `Indicator-module__flex-column___SgJQq`,
	"flexRow": `Indicator-module__flex-row___DXfog`,
	"verticallyCentered": `Indicator-module__vertically-centered___iwERM`,
	"horizontallyCentered": `Indicator-module__horizontally-centered___Qs7CG`,
	"horizontallyEnd": `Indicator-module__horizontally-end___GMfL_`,
	"verticallyStart": `Indicator-module__vertically-start___ykFih`,
	"spaceBetween": `Indicator-module__space-between___VOKvl`,
	"flexWrap": `Indicator-module__flex-wrap___W6RA9`,
	"height100": `Indicator-module__height-100___HZKtS`,
	"width50": `Indicator-module__width-50___hcxPZ`,
	"width100": `Indicator-module__width-100___zecGv`,
	"cursorPointer": `Indicator-module__cursor-pointer___lmKkn`,
	"cursorNotAllowed": `Indicator-module__cursor-not-allowed___r5wOy`,
	"absoluteCentered": `Indicator-module__absolute-centered___vryzK`,
	"absolute": `Indicator-module__absolute___NRm_Q`,
	"relative": `Indicator-module__relative___Tshze`,
	"fixed": `Indicator-module__fixed___NZwdr`,
	"visible": `Indicator-module__visible___hAURK`,
	"invisible": `Indicator-module__invisible___lDtsY`,
	"col90": `Indicator-module__col-90___GaSHX`,
	"colAuto": `Indicator-module__col-auto___vZpcN`,
	"medicalTabs": `Indicator-module__medical-tabs___Y6Pch`,
	"medicalTableNew": `Indicator-module__medical-table-new___T8hTX`,
	"noPagination": `Indicator-module__no-pagination___prVm_`,
	"medicalTableEmpty": `Indicator-module__medical-table-empty___U3AO8`,
	"iconBtn": `Indicator-module__icon-btn___frUeg`,
	"searchIcon": `Indicator-module__search-icon___KFrk1`,
	"disableSelect": `Indicator-module__disable-select___cdqJX`,
	"breakWord": `Indicator-module__break-word___LdBTu`,
	"popupClearBtn": `Indicator-module__popup-clear-btn___Oi5OJ`,
	"scrollMB20": `Indicator-module__scroll-m-b-20___UMNBK`,
	"wrapper": `Indicator-module__wrapper___d4odd`,
	"text": `Indicator-module__text___ACaON`
};
module.exports = ___CSS_LOADER_EXPORT___;
